import * as constants from '@app/constants/index';
import * as models from '@app/models';

export interface IUserSignedInAction {
	type: constants.USER_SIGNED_IN;
	payload: models.IAppReduxAuthenticationState;
}

export interface IUserSignedOutAction {
	type: constants.USER_SIGNED_OUT;
}

export interface IUserSignedUpAction {
	type: constants.USER_SIGNED_UP;
	payload: models.IAppReduxAuthenticationState;
}

export interface IUserCloseAccountAction {
	type: constants.USER_CLOSE_ACCOUNT;
}

export type AuthActions = IUserSignedInAction | IUserSignedOutAction | IUserSignedUpAction | IUserCloseAccountAction;
export function userSignedInAction(authentication: models.IAppReduxAuthenticationState): IUserSignedInAction {
	return {
		type: constants.USER_SIGNED_IN,
		payload: authentication,
	};
}

export function userSignedOutAction(): IUserSignedOutAction {
	return {
		type: constants.USER_SIGNED_OUT,
	};
}
export function userSignedUpAction(authentication: models.IAppReduxAuthenticationState): IUserSignedUpAction {
	return {
		type: constants.USER_SIGNED_UP,
		payload: authentication,
	};
}
export function userClosedAccountAction(): IUserCloseAccountAction {
	return {
		type: constants.USER_CLOSE_ACCOUNT,
	};
}



// WEBPACK FOOTER //
// ./src/actions/account.actions.ts